/** Verify-success auth event (GA4 recommended names). `sign_up` only when verify data.isNewUser is true. */
export function authEventName(isNewUser: boolean): 'sign_up' | 'login' {
  return isNewUser === true ? 'sign_up' : 'login'
}

export const AUTH_EVENT_PARAMS = { method: 'otp' } as const
